<!-- eslint-disable no-underscore-dangle -->
<template>
  <div class="device">
      <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
        <div class="device-header">
          <a-row>
            <a-col :span="4">
              <a-button type="primary" @click="addHandler">添加设备</a-button>
            </a-col>
            <a-col :span="20" style="text-align: right">
              <a-form-model layout="inline" @submit="getList" @submit.native.prevent>
                <a-form-model-item>
                  <station-select type="input" v-model="search.station" />
                </a-form-model-item>
                <a-form-model-item>
                  <a-input v-model="search.name" placeholder="设备名称" allowClear></a-input>
                </a-form-model-item>
                <a-form-model-item>
                  <a-input v-model="search.idCode" placeholder="设备ID" allowClear></a-input>
                </a-form-model-item>
                <a-form-model-item style="margin-right:0">
                  <a-button
                    type="primary"
                    html-type="submit"
                    icon="search"
                    @click="getList"
                  >
                    查询
                  </a-button>
                </a-form-model-item>
              </a-form-model>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          :scroll="{ x: 1200, y: $store.getters.listTableHeight }"
          :pagination="pager"
          rowKey="_id"
          @change="change"
        >
          <span slot="status" slot-scope="text">
            <dtu-status :status="text" />
          </span>
          <span slot="dataChannel" slot-scope="text">
           <a-tag color="#87d068" v-if="text">是</a-tag>
           <a-tag color="#108ee9" v-else>否</a-tag>
          </span>
          <span slot="comfirm" slot-scope="text">
           <a-tag color="#87d068" v-if="text">是</a-tag>
           <a-tag color="#108ee9" v-else>否</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="editHandler(record)" v-has:editDevice>修改</a>
            <a-divider type="vertical" />
            <a @click="deleteHandler(record._id)" v-has:editDevice>删除</a>
            <a-divider type="vertical" />
            <a @click="syncStatus(record._id)" v-has:editDevice>同步状态</a>
            <a-divider type="vertical" />
            <a @click="gotoRemoteControl(record)" target="_blank">远程控制</a>
          </span>
        </a-table>
    </a-card>
    <a-modal v-model="visible" title="设备管理" @ok="handleSubmit">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="站点" prop="station" required>
          <station-select type="input" v-model="form.station" />
        </a-form-model-item>
        <a-form-model-item ref="name" label="设备名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入设备名称" />
        </a-form-model-item>
        <a-form-model-item ref="idCode" label="设备ID" prop="idCode" required>
          <a-input v-model="form.idCode" placeholder="请输入设备识别码" />
        </a-form-model-item>
        <a-form-model-item label="设备类型" prop="type" required>
          <a-select v-model="form.type" placeholder="请选择一个设备类型">
            <a-select-option value="DTU">DTU</a-select-option>
            <a-select-option value="Android">Android</a-select-option>
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="isDataChannel" label="数据通道" prop="isDataChannel" required>
          <a-switch v-model="form.isDataChannel" placeholder="请设置数据通道" />
        </a-form-model-item>
        <a-form-model-item ref="comfirm" label="确认状态" prop="comfirm" required>
          <a-switch v-model="form.comfirm" placeholder="请设置确认状态" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="desc" type="textarea">
          <a-input v-model="form.desc" placeholder="请输入备注" type="textarea" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  getDeviceList,
  modifyDevice,
  creatDevice,
  syncStatus,
  deleteDevice,
} from '../../api/device';
import { getToken } from '@/utils';

const columns = [
  {
    title: '站点名称',
    dataIndex: 'station.name',
    key: 'station.name',
  },
  {
    title: '设备名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '设备标识',
    dataIndex: 'idCode',
    key: 'idCode',
    ellipsis: false,
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '数据通道',
    dataIndex: 'isDataChannel',
    key: 'isDataChannel',
    scopedSlots: { customRender: 'dataChannel' },
  },
  {
    title: '确认状态',
    dataIndex: 'comfirm',
    key: 'comfirm',
    scopedSlots: { customRender: 'comfirm' },
  },
  {
    title: '创建时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
  {
    title: '备注',
    key: 'desc',
    dataIndex: 'desc',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  created() {
    this.getList();
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      columns,
      search: {},
      form: {
        isDataChannel: false,
      },
      list: [],
      pager: {},
      listloading: false,
      edit: false,
    };
  },
  computed: {
    rules() {
      return {};
    },
  },
  methods: {
    async getList() {
      this.listloading = true;
      const { data } = await getDeviceList(this.search);
      this.list = data.docs;
      this.pager = data.pager;
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    addHandler() {
      this.form = {
        isDataChannel: false,
      };
      this.openDialog();
    },
    async handleSubmit() {
      this.editLoading = true;
      if (this.edit) {
        await modifyDevice({ ...this.form });
      } else {
        await creatDevice({ ...this.form });
      }
      this.$message.success('提交成功');
      this.editLoading = false;
      this.closeDialog();
      this.getList();
    },
    editHandler({
      _id, station, idCode, name, desc, type, isDataChannel,
      comfirm,
    }) {
      this.edit = true;
      this.form = {
        _id,
        idCode,
        name,
        desc,
        type,
        isDataChannel,
        comfirm,
      };
      if(station) {
        this.form.station = station.id;
      }
      this.openDialog();
    },
    openDialog() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    async syncStatus(id) {
      try {
        await syncStatus(id);
        this.$message.success('更新状态成功');
        this.getList();
      } catch (error) {
        this.$message.error(error);
      }
    },
    async deleteHandler(id) {
      try {
        await deleteDevice(id);
        this.$message.success('删除成功');
        this.getList();
      } catch (error) {
        this.$message.error(error);
      }
    },
    gotoRemoteControl(record) {
      const { idCode, type } = record;
      if (type !== 'Android') {
        this.$message.error('请选择幕设备');
        return;
      }
      const token = getToken();
      const url = `${window.location.origin}/remote-control-v2.html?token=${token}&deviceId=${idCode}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less" scoped></style>
